import styles from './ArticleTitleUnderlineVariant.module.css';
import splitAroundTargetWord from '../utils/splitAroundTargetWord.js';
import PropTypes from 'prop-types';

const ArticleTitleUnderlineVariant = ({ title, variant }) => {
  const result = splitAroundTargetWord(title, variant);

  return (
    <>
      {result.map((title, idx) => {
        if (title === variant) {
          return (
            <span
              key={idx}
              className={styles.articleTitleUnderlineVariantWrapper}
            >
              <span className={styles.articleTitleUnderlineVariant}>
                {title}
              </span>
            </span>
          );
        } else {
          return <span key={idx}>{title}</span>;
        }
      })}
    </>
  );
};

ArticleTitleUnderlineVariant.displayName = 'ArticleTitleUnderlineVariant';

ArticleTitleUnderlineVariant.propTypes = {
  title: PropTypes.string,
  variant: PropTypes.string,
};

ArticleTitleUnderlineVariant.defaultProps = {
  title: '',
  variant: '',
};

export default ArticleTitleUnderlineVariant;
